import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading } from '@/decorators';

var AddModal = function (_super) {
  __extends(AddModal, _super);

  function AddModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.loading = false;
    _this.productList = [];
    _this.formData = _this.initFormData();
    _this.formDataRule = {
      product_sku: [{
        required: true,
        message: _this.t('请选择商品编码')
      }],
      additional_service_code_list: [{
        required: true,
        type: 'array',
        message: _this.t('请选择附加服务项')
      }]
    };
    return _this;
  }

  Object.defineProperty(AddModal.prototype, "isEdit", {
    get: function get() {
      return !!this.rowData && !!this.rowData.id;
    },
    enumerable: false,
    configurable: true
  });

  AddModal.prototype.initFormData = function (data) {
    if (data) {
      var warehouseCodeList = data.warehouse_code_list && data.warehouse_code_list.length > 0 ? data.warehouse_code_list : [];
      var additionalServiceCodeList = data.additional_service_item_list && data.additional_service_item_list.length > 0 ? data.additional_service_item_list.map(function (item) {
        return item.additional_service_code;
      }) : [];
      return {
        id: data.id,
        product_sku: data.product_sku || '',
        additional_service_code_list: additionalServiceCodeList,
        warehouse_code_list: warehouseCodeList
      };
    }

    return {
      product_sku: '',
      additional_service_code_list: [],
      warehouse_code_list: []
    };
  };

  AddModal.prototype.handleSearchSkuList = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.queryProductList(value)];

          case 1:
            return [2, _a.sent()];
        }
      });
    });
  };

  AddModal.prototype.queryProductList = function (productSku) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.queryProductList({
              page_index: 1,
              page_size: 100,
              product_sku_list: [productSku],
              product_status: this.$enum.product.ProductStatusEnum.AVAILABLE,
              is_select_flag: true
            }, {
              loading: false
            })];

          case 1:
            data = _a.sent().data;
            this.productList = data.list || [];
            return [2, data.list || []];
        }
      });
    });
  };

  AddModal.prototype.handleCheckSelectedProductSku = function (sku) {
    var item = this.$util.findItemByKeyValue(this.productList, sku, 'product_sku');

    if (!item && sku) {
      this.formData.product_sku = '';
    }
  };

  AddModal.prototype.handleSelectProductSku = function () {};

  AddModal.prototype.buildPostData = function () {
    var _this = this;

    var additionalServiceCodeList = this.formData.additional_service_code_list.map(function (code) {
      var serviceItem = _this.additionalServiceItemList.find(function (item) {
        return item.value === code;
      });

      if (!serviceItem) {
        return {
          additional_service_code: code,
          additional_service_name: code
        };
      }

      return {
        additional_service_code: serviceItem.value,
        additional_service_name: serviceItem.text
      };
    });
    var postData = {
      product_sku: this.formData.product_sku,
      warehouse_code_list: this.formData.warehouse_code_list,
      additional_service_code_list: additionalServiceCodeList
    };

    if (this.isEdit && this.formData.id) {
      postData.id = this.formData.id;
    }

    return postData;
  };

  AddModal.prototype.handleSave = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef, valid, postData, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formDataRef = this.$refs.formDataRef;
            return [4, new Promise(function (resolve) {
              formDataRef.validate(function (isValid) {
                resolve(isValid);
              });
            })];

          case 1:
            valid = _a.sent();

            if (!valid) {
              return [2];
            }

            postData = this.buildPostData();
            _a.label = 2;

          case 2:
            _a.trys.push([2, 4,, 5]);

            return [4, this.$api.product.addOrEditAdditionalServicesConfig(postData)];

          case 3:
            _a.sent();

            this.$message.success(this.t('保存成功'));
            this.$emit('success');
            this.handleClose();
            return [3, 5];

          case 4:
            error_1 = _a.sent();
            return [3, 5];

          case 5:
            return [2];
        }
      });
    });
  };

  AddModal.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  AddModal.prototype.onVisibleChange = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!value) return [3, 1];
            formDataRef = this.$refs.formDataRef;
            this.formData = this.initFormData();
            this.productList = [];
            formDataRef && formDataRef.resetFields();
            return [3, 3];

          case 1:
            this.formData = this.initFormData(this.rowData);
            if (!(this.isEdit && this.formData.product_sku)) return [3, 3];
            return [4, this.queryProductList(this.formData.product_sku)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2];
        }
      });
    });
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], AddModal.prototype, "visible", void 0);

  __decorate([Prop({
    type: Object,
    "default": null
  })], AddModal.prototype, "rowData", void 0);

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], AddModal.prototype, "additionalServiceItemList", void 0);

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], AddModal.prototype, "warehouseList", void 0);

  __decorate([loading('loading')], AddModal.prototype, "handleSave", null);

  __decorate([Watch('visible', {
    immediate: true
  })], AddModal.prototype, "onVisibleChange", null);

  AddModal = __decorate([Component], AddModal);
  return AddModal;
}(Vue);

export default AddModal;